// Does this api state read master data over agave?
//
// Gated on the dataSource resolver rather than on the presence of an
// `agaveAdapter`: the adapter exists for every browser user, so keying off it
// would send everyone over HTTP.
//
// The resolver's answer is the same for every domain today; the domain argument
// is passed for the reader's benefit and so a later per-domain policy has a
// call site to change.
const readsViaAgave = (state, domain) =>
  !!(state && state.dataSource) && state.dataSource(domain) === 'agave'

module.exports = { readsViaAgave }
